import EntityListModel from "../../entity/_model/EntityListModel";
import AudienceModel from "./AudienceModel";

export default class AudienceListModel extends EntityListModel<AudienceModel> {

}